import React, { Component } from 'react';
import images from '../../config/images';
import AppBartemp from 'material-ui/AppBar';
import Display from 'material-ui/svg-icons/av/airplay';
import Profile from '../../components/Profile/NavBarProfile';
import { FormattedMessage } from 'react-intl';
import Chip from 'material-ui/Chip';
import { isWebinar, detectmob, isSpacee, isFVlite } from '../../lib/lib'
import FlatButton from 'material-ui/FlatButton';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import NotificationSystem from 'react-notification-system';

const Title = ({ mode, tableName, confName }) => (
  <div className='flex items-center'>
    <Display style={{ fill: '#fff' }} />
    <div style={{ fontSize: 20, marginLeft: "10px" }}>
      {confName}
    </div>
  </div>
);

const backgroundImage = () => {
    if(isSpacee()){
      return "linear-gradient( to right bottom, #4CB89C, #1A96D5 )"
    }
    if(isWebinar()){
      return "linear-gradient(135deg, #3186f9 0%, #3186f9 30%, #3186f9 90%, #3186f9 100%)"
    }
    if(isFVlite()){
      return "linear-gradient( to left bottom, #E3FEF1,#4AC6C3 )"
    }
    else{
      return "linear-gradient(135deg, rgba(255, 31, 14, 0.8) 0%, rgba(255, 47, 244, 0.8) 30%, rgba(255, 139, 22, 0.8) 90%, rgba(255, 213, 25, 0.8) 100%)"
    }
}

const invitationbuttonImage = () => {
  if(isSpacee()){
    return "linear-gradient( to right bottom, #4CB89C, #1A96D5 )"
  }
  if(isWebinar()){
    return "linear-gradient(135deg, #3186f9 0%, #3186f9 30%, #3186f9 90%, #3186f9 100%)"
  }else{
    return "linear-gradient(135deg, rgba(255, 31, 14, 0.8) 0%, rgba(255, 47, 244, 0.8) 30%, rgba(255, 139, 22, 0.8) 90%, rgba(255, 213, 25, 0.8) 100%)"
  }
}

class AppBar extends Component{
  constructor(props) {
    super(props)
    this.notificationSystem = React.createRef();
  }
   handlePopupStatus = () => {
    const notification = this.notificationSystem.current;
    notification.addNotification({
      message: 'URLがコピーされました',
      level: 'success',
      position: 'tc',
      autoDismiss: 3
    });
  }
  render(){
    const {direct, location, mode, tableName, user_id, name, role, email, init, confName, sessionsPremiumRoom} = this.props
    const notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          fontSize: '14px',
          height: '2.5vw',
          width: '25vw',
          right: '5vw',
          top: '-4vw !important',
        }
      }
    }
    return(<div>
      <AppBartemp
      className='pr3 pl3'
      style={{
        backgroundImage: backgroundImage(),
        zIndex: 100,
        height: isWebinar() ? "6vh" : "7vh",
        position: "unset"
      }}
      title={
        <div className='flex items-cente justify-between w-100'>
  
        { isWebinar() && <div>
          <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top: "1.0vh", left: "1vw", height: "4vh"}}>    
            <img src={images.webinar_logo} alt="logo" style={{ width: 120, cursor: "pointer" }} onClick={()=> {window.open('https://webinar.freshvoice.net/')}} />
          </div>
          <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top: "1.0vh", left: "25vw", height: "4vh"}}>
          { !init && <Chip backgroundColor='#ffc514'>
                <div className='white ttu'>
                  {(mode == "seminar") ? (<FormattedMessage id='main.seminar' />) : (<FormattedMessage id='main.breakout' />)}
                </div>
          </Chip>}
          </div>
          <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top: "1.0vh", left: "50vw", height: "4vh"}}>
          { !init && <div className='w-60 flex justify-center'>
            <Title mode={mode} tableName={tableName} confName={confName} />
          </div> }
          </div>
        </div>}
        { isFVlite() && <div>
          <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top: "1.0vh", left: "1vw", height: "4vh"}}>    
            <img src={images.FVlite_logo} alt="logo" style={{ width: 120, cursor: "pointer" }} onClick={()=> {window.open('https://www.freshvoice.net/lite/')}} />
          </div>
        </div>}
  
  
        { !isWebinar() && <div>
          {!isFVlite() && 
          <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top: "1.5vh", left: "1vw", height: "4vh"}}>
            <img src={isSpacee() ? images.spacee_logo :  images.dd_logo} alt="logo" style={{ width: isSpacee()? "20vw" : "3.5vw",  cursor: "pointer" }} onClick={()=> {window.open('/')}} />
          </div>
          }
          { !detectmob() && <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top: isSpacee()? "1.2vh" : "1.0vh", left: isSpacee()? "24vw" : "7vw", height: "5vh"}}>
            <CopyToClipboard text={window.location.href}
              onCopy={() => {this.handlePopupStatus()}}>
              <FlatButton 
                  label={"招待URLをコピー"}
                  hoverColor= {isSpacee() ? "#E84F4C" : '#1d8e5d' }
                  backgroundColor={isFVlite() ? "#009944" : isSpacee() ? '#E84F4C' :'#29B87A'  }
                  style={{left: isFVlite() ? '25px': '0px'}}
                  labelStyle={{color: '#FFFFFF'}}/>
            </CopyToClipboard>
        </div> }
        {!isFVlite() &&
          <div className='pl3 flex justify-around flex-column' style={{ position: "absolute", top:  isSpacee()? "1.7vh" : "1.5vh", left: isSpacee()? "40vw": "25vw", height: "4vh"}}>
          { !init && !detectmob() &&  <Chip backgroundColor={isSpacee()? 'rgba(255, 255, 255)' : "#ffc514"}  labelColor={ isSpacee()? "rgba(26, 150, 213)" : "white"} >
                <div className='ttu' >
                  {sessionsPremiumRoom ? "プレミアム(P2P)" : "無料" }
                </div>
          </Chip> }
          </div>
        }
          </div>}
          
          <div className='w-20' />
        </div>
      }
      iconElementRight={ isWebinar() ? <Profile direct={direct} user_id={user_id} name={name} role={role} email={email} location={location} /> : null }
      showMenuIconButton={false}
    />
    <div>
      <NotificationSystem ref={this.notificationSystem}  style={notificationStyle}/>
    </div>
    </div>
    )
  }
}

export default AppBar;



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/AppBar.js